import React, { useState, useEffect } from 'react';
import { Search, Bell, ChevronDown } from 'lucide-react';
import { Input } from './ui/input';

const Navbar = ({ onSearch }) => {
  const [scrolled, setScrolled] = useState(false);
  const [showSearch, setShowSearch] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 0);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchQuery(value);
    if (onSearch) {
      onSearch(value);
    }
  };

  return (
    <nav
      className={`fixed top-0 w-full z-50 transition-all duration-300 ${
        scrolled ? 'bg-[#141414]' : 'bg-gradient-to-b from-black/80 to-transparent'
      }`}
    >
      <div className="flex items-center justify-between px-4 md:px-12 py-4">
        <div className="flex items-center space-x-8">
          <h1 className="text-[#E50914] text-3xl font-bold tracking-tight cursor-pointer">
            BINGEBOX
          </h1>
          <div className="hidden md:flex space-x-6">
            <a href="#" className="text-white hover:text-gray-300 transition-colors text-sm font-medium">
              Home
            </a>
            <a href="#" className="text-white hover:text-gray-300 transition-colors text-sm font-medium">
              TV Shows
            </a>
            <a href="#" className="text-white hover:text-gray-300 transition-colors text-sm font-medium">
              Movies
            </a>
            <a href="#" className="text-white hover:text-gray-300 transition-colors text-sm font-medium">
              New & Popular
            </a>
            <a href="#" className="text-white hover:text-gray-300 transition-colors text-sm font-medium">
              My List
            </a>
          </div>
        </div>

        <div className="flex items-center space-x-6">
          {showSearch ? (
            <div className="relative">
              <Input
                type="text"
                placeholder="Titles, people, genres"
                value={searchQuery}
                onChange={handleSearch}
                className="bg-black/70 border border-white/80 text-white placeholder:text-gray-400 w-64 h-8 text-sm"
                autoFocus
              />
            </div>
          ) : (
            <Search
              className="text-white cursor-pointer hover:text-gray-300 transition-colors"
              size={20}
              onClick={() => setShowSearch(true)}
            />
          )}
          <Bell className="text-white cursor-pointer hover:text-gray-300 transition-colors" size={20} />
          <div className="flex items-center space-x-2 cursor-pointer group">
            <div className="w-8 h-8 rounded bg-gradient-to-br from-blue-500 to-purple-600 flex items-center justify-center">
              <span className="text-white text-sm font-semibold">B</span>
            </div>
            <ChevronDown className="text-white group-hover:rotate-180 transition-transform" size={16} />
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
